import { FieldInstruction, FormValues } from 'containers/FormBuilder'
import InputField from 'form/fieldComponents/InputField'
import SelectField from 'form/fieldComponents/SelectField'
import {
    streetAddress,
    city,
    state as stateField,
    zipCode,
} from 'form/fields/addressFields'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

function dealershipNameValidation(): (
    formValues: FormValues,
) => Yup.StringSchema {
    return (formValues) => {
        return Yup.string().required(FIELD_REQUIRED)
    }
}

export function createDealershipNameField(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Legal Company Name of Dealership',
            validator: dealershipNameValidation(),
        },
    }
}

export function createSalesPersonField(): FieldInstruction<typeof InputField> {
    return {
        Component: InputField,
        config: {
            label: 'Sales Person',
            validator: dealershipNameValidation(),
        },
    }
}

export function createDealerAddressField(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            ...streetAddress.config,
            label: 'Dealer Address',
        },
    }
}

export function createDealerCityField(): FieldInstruction<typeof InputField> {
    return {
        Component: InputField,
        config: {
            ...city.config,
            label: 'Dealer City',
        },
    }
}

export function createDealerStateField(): FieldInstruction<typeof SelectField> {
    return {
        Component: SelectField,
        config: {
            ...stateField.config,
            label: 'Dealer State',
        },
    }
}

export function createDealerZipField(): FieldInstruction<typeof InputField> {
    return {
        Component: InputField,
        config: {
            ...zipCode.config,
            label: 'Dealer Zip',
        },
    }
}
